// Randomly shuffles the array in place using Fisher-Yates algorithm.
// Each permutation has equal probability.
export function shuffle(array) {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export function reverseWord(word) {
  return [...word].reverse().join('');
}

export function toWordArray(wordsList) {
  return typeof wordsList === 'string' ? wordsList.split('\n') : wordsList;
}

export function toWordString(wordsList) {
  return typeof wordsList === 'string' ? wordsList : wordsList.join('\n');
}

export function getLength(wordsList) {
  return typeof wordsList === 'string' ? wordsList.split('\n').length : wordsList.length;
}

export function getUnplacedWords(wordsList, placedWords) {
  const list = toWordArray(wordsList);
  const placed = placedWords.map(w => w.word);

  return list.filter(
    word =>
      !placed.includes(word) && !placed.includes(reverseWord(word)),
  );
}

export function getPlacedWords(wordsList, placedWords) {
  const list = toWordArray(wordsList);
  const placed = placedWords.map(w => w.word);

  return list.filter(
    word =>
      placed.includes(word) || placed.includes(reverseWord(word)),
  );
}

export function normalizeWord(word) {
  return word.trim().toUpperCase();
}

export function splitByComma(text) {
  return text
    .split(',')
    .map(word => word.trim())
    .join('\n');
}

export function removeDuplicateLines(text) {
  text = splitByComma(text);
  return text.replace(/\n+/g, '\n');
}

export function removeEmpty(text) {
  const list = text.split('\n');
  return list.filter(item => item.trim() !== '');
}

export function filterWordsToAvoidSubWords(words) {
  const filtered = [];

  words.forEach(word => {
    let isSubWord = false;

    filtered.forEach(existing => {
      if (existing.includes(word)) {
        isSubWord = true;
      }
    });

    if (!isSubWord) {
      filtered.push(word);
    }
  });

  return filtered;
}

export function getWordList(list) {
  const formattedWordsList = removeDuplicateLines(list);
  return [...formattedWordsList.split('\n')];
}

export function formatWord(word, direction) {
  const isInverted = direction.includes('inverted');
  return isInverted ? word.split('').reverse().join('') : word;
}

export function prepareWords(list, enableSubWord, game) {
  let formattedList = getWordList(list)
    .map(word => normalizeWord(word))
    .sort((a, b) => b.length - a.length);

  game.settings.wordsList = formattedList;

  if (enableSubWord) {
    formattedList = filterWordsToAvoidSubWords(formattedList);
  }

  return formattedList;
}

export function prepareWord(word, directionStrategy) {
  const shouldReverse = directionStrategy
    .toLowerCase()
    .includes('inverted');
  return shouldReverse ? reverseWord(word) : word;
}

